import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Group, SegmentedControl, Text } from "@mantine/core"
import type { TVoxTheme } from "../../../lib/theme-mode"
import type { IViewProps } from "./interfaces"

function isVoxTheme(value: string): value is TVoxTheme {
  return value === "fantasy" || value === "scifi"
}

/**
 * Dumb view for VoxcanonThemeToggle. The smart wrapper at ../index.tsx owns
 * the document-attribute sync + cookie persistence + server mutation; this
 * component is a controlled segmented control between Fantasy and Sci-Fi.
 */
export const VoxcanonThemeToggleView = ({
  currentTheme,
  onChange,
  disabled = false,
}: IViewProps): React.JSX.Element => {
  const { i18n } = useLingui()

  const handleChange = (next: string): void => {
    if (!isVoxTheme(next)) return
    onChange(next)
  }

  return (
    <Group gap="xs" align="center">
      <Text size="xs" c="dimmed" tt="uppercase" fw={600} style={{ letterSpacing: "0.1em" }}>
        <Trans>Theme</Trans>
      </Text>
      <SegmentedControl
        size="xs"
        value={currentTheme}
        onChange={handleChange}
        disabled={disabled}
        data={[
          { label: i18n._(msg`Fantasy`), value: "fantasy" },
          { label: i18n._(msg`Sci-Fi`), value: "scifi" },
        ]}
      />
    </Group>
  )
}
